import { Tooltip as GpsTooltip } from 'react-leaflet';
import { gpsWarning } from '../../utils/gps-warning';
import { heartbeatTargetsEquipment } from "../../utils/heartbeat-events";
import { calculateMaintenanceDowntimeSeconds } from '../../utils/machine-maintenance';
import { dateInputValue, isHistoricalRange, dashboardReferenceTime } from '../../utils/dashboard-range';
import React, { useState, useEffect, useLayoutEffect, useRef, useContext } from 'react';
import { GlobalContext } from 'context/userContext';
import { DrawerHeader } from '@components/drawer-header';
import * as S from './styles';

import PieDistribuionEquipament from '@components/charts/pie_distribution_chart';
import BarDistributionChart from '@components/charts/bar_distribution_chart';
import LinePerTimeChart from '@components/charts/line_per_time_chart';
import HeartbeatTimelineChart, { TimelineRangeDataPoint } from '@components/charts/heartbeat_timeline_chart';

import { Grid, Typography, Box, Alert } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import TableExplorer from '@components/table-explorer/table_explorer';
import ImuChartModal from '@components/imu-chart-modal/imu_chart_modal';
import { AxiosInstanceLongTimeOut, API_URL, AxiosInstance } from '@service/axios-instance';
import { getAllQuestionsMap } from '@pages/checklist-config/api';
import { buildBoundedDateRange } from '../../utils/date-range';
import { secondsSinceTelemetryTimestamp } from '../../utils/telemetry-time';
import { getMachineIcon, STATE_COLORS } from '../../utils/machine-icon';


import {
  MapContainer, TileLayer, Marker, Popup, Polyline, ImageOverlay,
  LayersControl, LayerGroup, useMap, Polygon
} from 'react-leaflet'
import L from 'leaflet';
import "leaflet/dist/leaflet.css"
import { HeatmapLayer } from 'react-leaflet-heatmap-layer-v3';
import { LatLngExpression, LatLngBoundsExpression, } from 'leaflet';
import { RotatedImageOverlay } from '@components/map/leaflet-image-overlay-rotated';
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});






// points (timestamped coordinates)
type Position = {
  lat: number;
  lng: number;
  timestamp: string;
  user?: string | number;
};


// Custom image and bounds (your floorplan should be ~2x1 ratio for this example)
const imageUrl = 'https://vitruvius.com.br/media/images/magazines/grid_12/ca3d_inst47-08.jpg';  // Put this in your `public/` folder

// You must calibrate these bounds to match real GPS coordinates
const imageBounds: LatLngBoundsExpression = [
  [-23.5510, -46.6340], // Southwest (bottom-left)
  [-23.5500, -46.6320], // Northeast (top-right)
];


interface MapCenterChangerProps {
  center: LatLngExpression;
  equipament: string | null;
}

const MapCenterChanger = ({ center, equipament }: MapCenterChangerProps) => {
  const map = useMap();
  const prevEquipament = useRef<string | null>(equipament);
  const hasFitted = useRef(false);

  useEffect(() => {
    if (prevEquipament.current !== equipament) {
      hasFitted.current = false;
      prevEquipament.current = equipament;
    }

    if (!hasFitted.current) {
      const lat = Array.isArray(center) ? center[0] : (center as any).lat;
      const lng = Array.isArray(center) ? center[1] : (center as any).lng;

      // Avoid snapping to the default empty center [-23.5525, -46.615] if we don't have GPS yet
      if (lat !== -23.5525 && lng !== -46.6150) {
        map.setView(center, 18);
        hasFitted.current = true;
      }
    }
  }, [center, map, equipament]);

  return null;
};





export function EquipamentDashboard() {
  const firstLoadRef = useRef(true);


  const { operation, equipament, startDate, endDate, setStartDate, setEndDate } = useContext(GlobalContext);
  const theme = useTheme();
  const historical = isHistoricalRange(endDate);
  const referenceTime = dashboardReferenceTime(endDate);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const tableInstanceRef = useRef<any>(null);

  const handleRowAction = (dtRow: any) => {
    if (!tableInstanceRef.current) return;

    const dataArray = dtRow.data();
    if (!dataArray) return;

    const columns = tableInstanceRef.current.settings()[0].aoColumns;
    const rowObj: any = {};
    columns.forEach((col: any, index: number) => {
      const colName = col.sTitle || col.title || col.name || String(index);
      rowObj[colName] = dataArray[index];
    });

    if (rowObj.type === 'crash' || rowObj.type === 'crash_fwd' || rowObj.type === 'crash_rev' || rowObj.type === 'hole' || rowObj.type === 'imu_record') {
      rowObj.tid = rowObj.tid || rowObj.id;
      setSelectedEvent(rowObj);
      setModalOpen(true);
    }
  };



  const [machineDescription, setMachineDescription] = React.useState("");
  const [isReserve, setIsReserve] = React.useState("");
  const [setor, setSetor] = React.useState("");

  const [estado, setEstado] = React.useState("");
  const [userLogged, setUserLogged] = React.useState("");
  const [usersMap, setUsersMap] = React.useState<Record<string, string>>({});
  const [horimetro, setHorimetro] = React.useState("");
  const [proxPreventiva, setProxPreventiva] = React.useState("");
  const [horasContratadas, setHorasContratadas] = React.useState(undefined);

  type DataPoint = { x: Date; y: number };
  const [horimetroDatapoins, setHorimetroDatapoins] = React.useState<DataPoint[]>([]);
  type DataPiePoint = { label: string; y: number; color?: string; };
  const [disponibilidadeDataPiePoins, setDisponibilidadeDataPiePoins] = React.useState<DataPiePoint[]>([]);
  const [eventsDataPiePoins, setEventsDataPiePoins] = React.useState<DataPiePoint[]>([]);
  const [usoDataPiePoins, setUsoDataPiePoins] = React.useState<DataPiePoint[]>([]);

  const [positions, setPositions] = React.useState<Position[]>([]);
  const [multiPolyline, setMultiPolyline] = React.useState<LatLngExpression[][]>([]);
  const [mapCenter, setMapCenter] = React.useState<LatLngExpression>([-23.5525, -46.6150]);
  const [areas, setAreas] = React.useState<any[]>([]);

  React.useEffect(() => {
    if (!operation) return;
    const requestURL = operation ? "/geofences/get_geofences?db=" + operation : "/geofences/get_geofences";
    AxiosInstanceLongTimeOut.post(requestURL, {}, { withCredentials: true })
      .then((res) => {
        const adapted = (res.data || []).map((r: any) => ({
          ...r,
          points: Array.isArray(r.points) ? r.points.map((p: any) => (Array.isArray(p) ? { lat: p[0], lng: p[1] } : p)) : []
        }));
        setAreas(adapted);
      })
      .catch((error) => console.log(error));
  }, [operation]);

  interface Series {
    type: "line" | "column" | "pie" | string;
    showInLegend: boolean;
    name: string;
    xValueFormatString: string;
    dataPoints: DataPoint[];
  }

  const [eventsPerTimeDatapoins, setEventsPerTimeDatapoins] = React.useState<Series[]>([]);
  const [utilizacaoPerTimeDatapoins, setUtilizacaoPerTimeDatapoins] = React.useState<Series[]>([]);
  const [usoDiarioBarPoints, setUsoDiarioBarPoints] = React.useState<Series[]>([]);

  const [rawHeartbeats, setRawHeartbeats] = React.useState<any[]>([]);
  const [rawEvents, setRawEvents] = React.useState<any[]>([]);
  const [timelineRangePoints, setTimelineRangePoints] = React.useState<TimelineRangeDataPoint[]>([]);
  const [useMaintenanceModule, setUseMaintenanceModule] = React.useState(false);

  const [questionsMap, setQuestionsMap] = React.useState<Record<string, { text: string; answers: { value: string; label: string }[] }[]>>({});
  const [mapLoaded, setMapLoaded] = React.useState(false);

  React.useEffect(() => {
    if (operation) {
      Promise.all([
        getAllQuestionsMap(operation),
        AxiosInstance.post(`/users-machine/get_users-machine?db=${encodeURIComponent(operation)}`, {}, { withCredentials: true })
      ])
        .then(([qMap, uRes]) => {
          setQuestionsMap(qMap);

          const uMap: Record<string, string> = {};
          if (uRes.data && Array.isArray(uRes.data)) {
            uRes.data.forEach((u: any) => {
              if (u.login !== undefined && u.login !== null && u.login !== "") {
                const loginStr = u.login.toString().trim().toLowerCase();
                uMap[loginStr] = u.name || "";
                if (loginStr !== "" && !isNaN(Number(u.login))) {
                  uMap[Number(u.login).toString()] = u.name || "";
                }
              }
            });
          }
          setUsersMap(uMap);
          setMapLoaded(true);
        })
        .catch((e) => {
          console.error(e);
          setMapLoaded(true);
        });
    }
  }, [operation]);

  const mapStatus = (status: number) => {
    switch (status) {
      case 6: return "Incompleto";
      case 7: return "Alerta";
      case 8: return "Bloqueado";
      case 9: return "Aprovado";
      default: return `Desconhecido (${status})`;
    }
  };



  const [equipamentData, setEquipamentData] = React.useState<any | null>(null);
  const [intHorimetro, setIntHorimetro] = React.useState<number | null>(null);
  const [firstHeartbeat, setFirstHeartbeat] = React.useState<any | null>(null);
  const [lastHeartbeat, setLastHeartbeat] = React.useState<any | null>(null);
  const [lastValidGps, setLastValidGps] = React.useState<any | null>(null);
  const [approxLocation, setApproxLocation] = React.useState<{ lat: number, lng: number } | null>(null);
  const [maintenancesData, setMaintenancesData] = React.useState<any[] | null>(null);
  const [mapOverlay, setMapOverlay] = React.useState<any>(null);


  interface DayStats {
    ligado: number;
    parado: number;
  }



  const request_dict = {
    "start_date": startDate,
    "end_date": endDate,
    match_filters_dict: {
      "id": equipament
    }
  }
  const request_config = { withCredentials: true };

  function getDateRange(start?: Date, end?: Date): Date[] {
    return buildBoundedDateRange(start, end);
  }

  //-----------------------------------------------------
  //-----------------------------------------------------

  const [sseTrigger, setSseTrigger] = React.useState(0);
  const [sseEqTrigger, setSseEqTrigger] = React.useState(0);

  useEffect(() => {
    if (historical) return;
    const sse = new EventSource(API_URL + 'sse/stream');
    sse.addEventListener('equipaments', (e: any) => {
      try {
        const data = JSON.parse(e.data);
        if (data.db && data.db !== operation) return;
      } catch (err) { }
      setSseEqTrigger(c => c + 1);
    });
    sse.addEventListener('heartbeat', (e: any) => {
      try {
        const data = JSON.parse(e.data);
        if (!heartbeatTargetsEquipment(data, operation, equipament)) return;
      } catch (err) { return; }
      setSseTrigger(c => c + 1);
    });
    return () => { sse.close(); };
  }, [operation, historical, equipament]);

  useEffect(() => {
    if (operation == null) return;

    AxiosInstanceLongTimeOut.get('/operations/current_config', { params: { db: operation }, withCredentials: true })
      .then((res: any) => {
        if (res.data && res.data.USE_MAINTENANCE_MODULE) {
          setUseMaintenanceModule(true);
        } else {
          setUseMaintenanceModule(false);
        }
        if (res.data && res.data.MAP_OVERLAY) {
          setMapOverlay(res.data.MAP_OVERLAY);
        } else {
          setMapOverlay(null);
        }
      })
      .catch((err: any) => console.log('Error fetching operation config:', err));

    const refreshData = () => {
      fetchEquipamentsData();
      fetchHeartbeatData();
      fetchEventsData();
      fetchMaintanencesData();
    };

    refreshData();
  }, [operation, equipament, startDate, endDate, sseEqTrigger, sseTrigger]);

  useEffect(() => {
    if (!operation) return;
    AxiosInstanceLongTimeOut.post('/users-machine/get_users-machine?db=' + operation, {}, { withCredentials: true })
      .then((res: any) => {
        const map: Record<string, string> = {};
        if (Array.isArray(res.data)) {
          res.data.forEach((u: any) => {
            const userName = u.name || u.nome || u.username || String(u.login || u.rfid_uuid || "");

            if (u.login !== undefined && u.login !== null && u.login !== "") {
              const loginStr = u.login.toString().trim().toLowerCase();
              map[loginStr] = userName;
              map[u.login.toString()] = userName;
              if (loginStr !== "" && !isNaN(Number(u.login))) {
                map[Number(u.login).toString()] = userName;
              }
            }

            if (u.rfid_uuid !== undefined && u.rfid_uuid !== null && u.rfid_uuid !== "") {
              const rfidStr = u.rfid_uuid.toString().trim().toLowerCase();
              map[rfidStr] = userName;
              map[u.rfid_uuid.toString()] = userName;
              if (rfidStr !== "" && !isNaN(Number(u.rfid_uuid))) {
                map[Number(u.rfid_uuid).toString()] = userName;
              }
            }
          });
        }
        setUsersMap(map);
      })
      .catch(console.error);
  }, [operation]);





  //----------------------data processing-----------------------------


  React.useEffect(() => {
    if (equipamentData && intHorimetro !== null) {
      const prox_preventiva_diff_horas = equipamentData["proxima_preventiva"] - intHorimetro;
      let previsao_dias = Math.floor((equipamentData["proxima_preventiva"] - intHorimetro) / 24);
      if (equipamentData["horas_contratadas"] != undefined) {
        previsao_dias = Math.floor((equipamentData["proxima_preventiva"] - intHorimetro) / equipamentData["horas_contratadas"]);
      }
      setProxPreventiva(prox_preventiva_diff_horas + " h - Previsão " + previsao_dias + " dias");
    }
  }, [equipamentData, intHorimetro]);

  React.useEffect(() => {
    if (maintenancesData) {
      const start = new Date(startDate);
      let end = new Date();
      if (endDate) {
        end = new Date(endDate);
      }
      const total_time_diffs = end.getTime() / 1000 - start.getTime() / 1000;

      let total_maintanence_diffs = calculateMaintenanceDowntimeSeconds(maintenancesData, start, end);

      let op_diffs = total_time_diffs - total_maintanence_diffs;
      if (Number.isNaN(op_diffs) || Number.isNaN(total_maintanence_diffs)) {
        op_diffs = 1;
        total_maintanence_diffs = 0;
      }
      setDisponibilidadeDataPiePoins([{ "label": "Operacional", y: Math.max(0, op_diffs), color: STATE_COLORS["Operando"] || '#4CAF50' }, { "label": "Manutenção", y: total_maintanence_diffs, color: STATE_COLORS["Manutenção"] || '#7b102a' }]);
    }
  }, [startDate, maintenancesData, endDate]);







  React.useEffect(() => {
    const points: TimelineRangeDataPoint[] = [];

    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    const minTimeMs = startDate ? new Date(startDate).getTime() : thirtyDaysAgo.getTime();

    const selectedHeartbeats = [...(rawHeartbeats || [])]
      .map((hb) => ({ ...hb, parsedStamp: new Date(hb.stamp + (hb.stamp.endsWith('Z') ? '' : 'Z')) }))
      .filter((hb) => !Number.isNaN(hb.parsedStamp.getTime()) && hb.parsedStamp.getTime() >= minTimeMs)
      .sort((a, b) => a.parsedStamp.getTime() - b.parsedStamp.getTime());

    for (let index = 0; index < selectedHeartbeats.length; index += 1) {
      const current = selectedHeartbeats[index];
      const next = selectedHeartbeats[index + 1];
      const currentState = Number(current.state);

      let color = '#9ca3af'; // gray (idle)
      let stateLabel = 'Ocioso';

      if (currentState === 4) {
        color = STATE_COLORS["Operando"] || '#4CAF50';
        stateLabel = 'Operando';
      } else if (currentState === 7) {
        color = STATE_COLORS["Manutenção"] || '#7b102a';
        stateLabel = 'Manutenção';
      } else if (currentState === 6) {
        color = STATE_COLORS["Atualizando"] || '#673AB7';
        stateLabel = 'Atualizando';
      } else if (currentState === 5) {
        color = STATE_COLORS["Bloqueado Remoto"] || '#D32F2F';
        stateLabel = 'Bloqueado Remoto';
      } else if (currentState === 3) {
        color = STATE_COLORS["Bloqueada"] || '#F44336';
        stateLabel = 'Bloqueada';
      } else if (currentState === 2) {
        color = STATE_COLORS["Checklist"] || '#FFB300';
        stateLabel = 'Checklist';
      } else if (currentState === 1) {
        color = STATE_COLORS["Login"] || '#e221f3ff';
        stateLabel = 'Login';
      } else if (currentState === 0) {
        color = STATE_COLORS["Desligado"] || '#2196F3';
        stateLabel = 'Desligado';
      } else if ((current.vx || 0) > 0) {
        color = '#10b981';
        stateLabel = 'Em Movimento';
      }

      if (next) {
        const endParsed = next.parsedStamp;
        const gapSeconds = (endParsed.getTime() - current.parsedStamp.getTime()) / 1000;
        let endTime = endParsed.getTime();
        const isNextLogin = Number(next.state) === 1;

        if (gapSeconds > 300 && (isNextLogin || currentState === 1)) {
          // Increased to 5 mins minimum so it doesn't disappear on a 30-day scale
          endTime = current.parsedStamp.getTime() + 5 * 60 * 1000;
        }

        const displayName = equipamentData?.apelido ? `${equipament} - ${equipamentData.apelido}` : String(equipament);
        points.push({
          x: 2,
          y: [current.parsedStamp.getTime(), endTime],
          color,
          label: displayName,
          toolTipContent: `<strong>${displayName}</strong><br/>Estado: ${stateLabel}<br/>Movimento: ${(current.vx || 0).toFixed(1)}<br/>Usuário: ${current.user || 'Desconhecido'}`
        });
      }
    }

    const selectedEvents = [...(rawEvents || [])]
      .map((evt) => ({ ...evt, parsedStamp: new Date(evt.stamp + (evt.stamp.endsWith('Z') ? '' : 'Z')) }))
      .filter((evt) => !Number.isNaN(evt.parsedStamp.getTime()) && evt.parsedStamp.getTime() >= minTimeMs)
      .sort((a, b) => a.parsedStamp.getTime() - b.parsedStamp.getTime());

    selectedEvents.forEach((evt) => {
      let eventColor = '#9ca3af';
      let eventType = 'Outro';

      const isCrash = evt.type === 'crash' || evt.type === 'batida' || evt.type === 'crash_fwd' || evt.type === 'crash_rev';
      const isHole = evt.type === 'hole' || evt.type === 'buraco';

      if (isCrash) {
        eventColor = '#ef4444';
        eventType = 'Batida/Impacto';
      } else if (isHole) {
        eventColor = '#eab308';
        eventType = 'Buraco';
      } else if (evt.category?.toLowerCase() === 'checklist' || evt.subcategory?.toLowerCase() === 'checklist') {
        eventColor = '#3b82f6';
        eventType = 'Checklist';
      }

      points.push({
        x: 1,
        // Increased to 10 mins wide so it doesn't disappear on a 30-day scale
        y: [evt.parsedStamp.getTime() - 5 * 60000, evt.parsedStamp.getTime() + 5 * 60000],
        color: eventColor,
        label: "Eventos",
        toolTipContent: `<strong>Evento: ${eventType}</strong><br/>${evt.category || ''} - ${evt.subcategory || ''}<br/>${evt.description || ''}<br/>Usuário: ${evt.user || 'Desconhecido'}`
      });
    });

    setTimelineRangePoints(points);
  }, [rawHeartbeats, rawEvents]);
  //----------------------------------------------------------------------------

  const fetchMaintanencesData = async () => {
    const tableName = "maintenances";
    const requestURL = "/" + tableName + "/get_" + tableName + "?db=" + operation;
    AxiosInstanceLongTimeOut.post(requestURL, { ...request_dict, start_date: undefined }, request_config)
      .then((response) => {
        setMaintenancesData((response.data || []).filter((ticket: any) => {
          const closed = ticket.stamp_end || ticket.closed_at;
          return !closed || new Date(closed) >= new Date(startDate);
        }));
      })
      .catch((error) => console.log(error));
  };


  const fetchEquipamentsData = async () => {
    const eq_request_dict = { match_filters_dict: { "id": equipament } };
    const tableName = "equipaments";
    const requestURL = "/" + tableName + "/get_" + tableName + "?db=" + operation;
    AxiosInstanceLongTimeOut.post(requestURL, eq_request_dict, request_config)
      .then((response) => {
        const eq = response.data[0];
        setMachineDescription(eq["tipo"] + " " + eq["marca"] + " modelo " + eq["modelo"] + " " + eq["ano"]);
        setSetor(eq["setor"]);
        setIsReserve(eq["reserva"] == 1 ? "Sim" : "Não");
        setHorasContratadas(eq["horas_contratadas"]);
        setEquipamentData(eq);
      })
      .catch((error) => console.log(error));
  };


  const fetchHeartbeatData = async () => {
    console.log("FEATCHHEARTBEAT");
    const tableName = "heartbeats";

    const last_hb_request_dict = {
      start_date: startDate,
      end_date: endDate,
      match_filters_dict: {
        "id": equipament
      }
    }

    const requestURL_Last = "/" + tableName + "/get_last_" + tableName + "_per_id?db=" + operation
    console.log("REQUEST_EQUIPAMENTS ", tableName, " requesting ", requestURL_Last);
    AxiosInstanceLongTimeOut.post(requestURL_Last, last_hb_request_dict, request_config)
      .then((response) => {
        //console.log(response.data);
        const hb = response.data?.[0];
        setLastHeartbeat(hb || null);
        if (!hb) {
          setEstado('Sem dados'); setUserLogged(''); setIntHorimetro(0); setHorimetro('Sem dados no período');
          return;
        }
        const diffSeconds = secondsSinceTelemetryTimestamp(hb["stamp"], referenceTime);
        // Heartbeat stamps without timezone are treated as UTC by telemetry-time.


        if (diffSeconds === null || diffSeconds > 60 * 5) { //5 minute
          setEstado(`Desligado`);
          setUserLogged(hb['user']);
        }
        else {
          setUserLogged(hb['user']);
          switch (hb['state']) {
            case 0:
              setEstado(`Desligado`);
              break;
            case 1:
              setEstado(`Login`);
              break;
            case 2:
              setEstado(`Checklist`);
              break;
            case 3:
              setEstado(`Bloqueada`);
              break;
            case 4:
              setEstado(`Operando`);
              break;
            case 5:
              setEstado(`Bloquead R`);
              break;
            case 6:
              setEstado(`Atualizando`);
              break;
            case 7:
              setEstado(`Manutenção`);
              break;
            default:
              setEstado(`???`);
          }
        }


        let parsedHorimetro = 0;
        if (response.data && hb["horimetro"] != null) {
          if (typeof hb["horimetro"] === 'number') {
            parsedHorimetro = hb["horimetro"];
          } else {
            parsedHorimetro = parseInt(hb["horimetro"], 10) || 0;
          }
        }
        const calcHorimetro = Math.round(parsedHorimetro / 60);
        setIntHorimetro(calcHorimetro);
        setHorimetro(calcHorimetro + " horas");




      })
      .catch((error) => {
        console.log(error)
      })

    const valid_gps_request_dict = { ...last_hb_request_dict, only_valid_gps: true };
    const requestURL_Valid_Gps = "/" + tableName + "/get_last_" + tableName + "_per_id?db=" + operation;
    AxiosInstanceLongTimeOut.post(requestURL_Valid_Gps, valid_gps_request_dict, request_config)
      .then((response) => {
        const gpsEntry = (response.data && response.data.length > 0) ? response.data[0] : null;
        setLastValidGps(gpsEntry);

        const lat = gpsEntry?.lat ?? gpsEntry?.latitude;
        const lng = gpsEntry?.lng ?? gpsEntry?.longitude;
        if (!historical && (lat === 0 || lng === 0 || lat == null || lng == null)) {
          AxiosInstanceLongTimeOut.post('/equipaments/approx_locations_batch?db=' + operation, { ids: [equipament] }, request_config)
            .then(res => {
              if (res.data && res.data[String(equipament)]) {
                setApproxLocation(res.data[String(equipament)]);
              }
            })
            .catch(err => console.error("Error fetching approx location:", err));
        }
      })
      .catch(err => console.error("Error fetching valid GPS", err));

    const requestURL = "/" + tableName + "/get_" + tableName + "?db=" + operation
    console.log("REQUEST_EQUIPAMENTS ", tableName, " requesting ", requestURL);
    AxiosInstanceLongTimeOut.post(requestURL, request_dict, request_config)
      .then((response) => {
        //console.log(response.data);

        const oneYearAgoMs = new Date(startDate).getTime();

        const datapoints: any[] = [];

        (response.data as any[]).forEach((hb_entry: any) => {
          const d = new Date(hb_entry["stamp"]);
          if (!Number.isNaN(d.getTime()) && d.getTime() >= oneYearAgoMs) {
            datapoints.push({ x: d, y: hb_entry["horimetro"] / 60 });
          }
        });

        /*
        datapoints = [{ x: new Date(2025, 3, 1), y: 1000 },
        { x: new Date(2025, 3, 2), y: 1020 },
        { x: new Date(2025, 3, 3), y: 1045 },
        { x: new Date(2025, 3, 4), y: 1060 },
        { x: new Date(2025, 3, 5), y: 1060 },
        { x: new Date(2025, 3, 6), y: 1060 },
        { x: new Date(2025, 3, 7), y: 1070 }];
         */

        setHorimetroDatapoins(datapoints);
        //console.log("horimetroDatapoints", datapoints);

        setFirstHeartbeat(response.data[0]);




        //map markers and paths
        const tmp_positions: Position[] = [];
        const tmp_multiPolyline: LatLngExpression[][] = [[]];
        let tmp_mapcenter: LatLngExpression = [-23.5525, -46.6150];

        for (let i = 0; i < response.data.length; i++) {
          if (response.data.length >= 50 && i % 60 != 0) continue;

          const hb_entry = response.data[i];

          if (hb_entry["latitude"] != 0 && hb_entry["longitude"] != 0) {
            tmp_positions.push({
              "lat": hb_entry["latitude"],
              "lng": hb_entry["longitude"],
              "timestamp": hb_entry["stamp"],
              "user": hb_entry["user"]
            });

            tmp_multiPolyline[0].push([hb_entry["latitude"], hb_entry["longitude"]]);
            tmp_mapcenter = [hb_entry["latitude"], hb_entry["longitude"]];
          }

        }

        setPositions(tmp_positions);
        setMultiPolyline(tmp_multiPolyline);
        if (tmp_mapcenter[0] !== -23.5525 && tmp_mapcenter[1] !== -46.6150) {
          setMapCenter(tmp_mapcenter);
        }

        setRawHeartbeats(response.data || []);

      })
      .catch((error) => {
        console.log(error)
      })


    const requestURL_aggregated = "/" + tableName + "/get_aggregated_" + tableName + "?db=" + operation

    const threeDaysAgo = startDate;

    //DISPONIBILIDADE PIE
    const hb_agregated_request_dict = {
      "collum_name_agregator": "vx",
      "date_unit_aggregator": "day",
      "start_date": threeDaysAgo,
      "end_date": endDate,
      match_filters_dict: {
        "id": equipament
      }
    }

    console.log("REQUEST_AG_HB ", tableName, " requesting ", requestURL_aggregated);
    AxiosInstanceLongTimeOut.post(requestURL_aggregated, hb_agregated_request_dict, request_config)
      .then((response) => {
        //console.log(response.data);

        const dateRange = getDateRange(threeDaysAgo, endDate);

        const days_dict: Record<string, DayStats> = {};
        dateRange.forEach(day => {
          const dateStr = day.toISOString().split("T")[0];
          days_dict[dateStr] = { "ligado": 0, "parado": 0 };
        });

        //console.log("full daydict",days_dict);

        let full_sum_parado = 0;
        let full_sum_movimento = 0;

        // Iterate over all returned keys (vx values)
        Object.keys(response.data).forEach((key) => {
          // Convert key to float (handles "1", "1.0", "0", "0.0", etc.)
          const vxValue = parseFloat(key);
          const records = response.data[key];

          if (isNaN(vxValue)) return;

          // Check if stopped (vx < 0.1) or moving
          if (Math.abs(vxValue) < 0.1) {
            // Ligado Parado (Stopped)
            records?.forEach((val: Record<string, number>) => {
              const date = Object.keys(val)[0];

              // Ensure existence (though initialized above, good practice)
              if (!days_dict[date]) {
                days_dict[date] = { "ligado": 0, "parado": 0 };
              }

              full_sum_parado += val[date];
              days_dict[date]["ligado"] += val[date];
              days_dict[date]["parado"] += val[date];
            });

          } else {
            // Ligado em Movimento (Moving)
            records?.forEach((val: Record<string, number>) => {
              const date = Object.keys(val)[0];

              if (!days_dict[date]) {
                days_dict[date] = { "ligado": 0, "parado": 0 };
              }

              full_sum_movimento += val[date];
              days_dict[date]["ligado"] += val[date];
            });
          }
        });

        //console.log(days_dict);

        const total_minutes = dateRange.length * 24 * 60;
        setUsoDataPiePoins(
          [
            { "label": "desligado", "y": Math.max(0, total_minutes - full_sum_movimento - full_sum_parado), color: STATE_COLORS["Desligado"] || '#2196F3' },
            { "label": "movimento", "y": full_sum_movimento, color: STATE_COLORS["Operando"] || '#4CAF50' },
            { "label": "ligado parado", "y": full_sum_parado, color: STATE_COLORS["Ocioso"] || '#9ca3af' },
          ]
        );

        const dataserieLigado: DataPoint[] = [];
        const dataserieLigadoParado: DataPoint[] = [];

        const minutes_per_hour = 60

        dateRange.forEach(day => {
          const dateStr = day.toISOString().split("T")[0];

          dataserieLigado.push({ "x": day, "y": days_dict[dateStr]["ligado"] / minutes_per_hour });
          dataserieLigadoParado.push({ "x": day, "y": days_dict[dateStr]["parado"] / minutes_per_hour });
        });


        const UtilizacaoDiaDataPoints: Series[] = [];
        UtilizacaoDiaDataPoints.push({
          type: "line",
          showInLegend: true,
          name: "Ligada",
          xValueFormatString: "MMM DD",
          dataPoints: dataserieLigado,
        })

        UtilizacaoDiaDataPoints.push({
          type: "line",
          showInLegend: true,
          name: "Osciosa",
          xValueFormatString: "MMM DD",
          dataPoints: dataserieLigadoParado,
        })

        setUtilizacaoPerTimeDatapoins(UtilizacaoDiaDataPoints);

        setUsoDiarioBarPoints([{
          type: "column",
          showInLegend: false,
          name: "Horas Trabalhadas",
          xValueFormatString: "MMM DD",
          dataPoints: dataserieLigado,
        }]);
      })
      .catch((error) => {
        console.log(error)
      })


  };

  useEffect(() => {
    if (approxLocation) {
      const lat = Array.isArray(mapCenter) ? mapCenter[0] : (mapCenter as any).lat;
      const lng = Array.isArray(mapCenter) ? mapCenter[1] : (mapCenter as any).lng;
      if (lat === -23.5525 && lng === -46.6150) {
        setMapCenter([approxLocation.lat, approxLocation.lng]);
      }
    }
  }, [approxLocation, mapCenter]);

























  const translateEventLabel = (k: string): string => {
    if (k === "`ogin" || k === "login") return "Login";
    if (k === "boot_anomaly") return "Erro Boot";
    if (k === "crash" || k === "batida") return "Impacto";
    if (k === "crash_fwd") return "Impacto (Frente)";
    if (k === "crash_rev") return "Impacto (Ré)";
    if (k === "hole" || k === "buraco") return "Buraco";
    return k;
  };

  const fetchEventsData = async () => {
    const tableName = "events";

    const requestURL = "/" + tableName + "/get_aggregated_" + tableName + "?db=" + operation

    //EVENTS PIE
    const ev_request_dict = {
      "collum_name_agregator": "type",
      "start_date": startDate,
      "end_date": endDate,
      match_filters_dict: {
        "id": equipament
      }
    }

    console.log("REQUEST_AG_EVENTS ", tableName, " requesting ", requestURL);
    AxiosInstanceLongTimeOut.post(requestURL, ev_request_dict, request_config)
      .then((response) => {
        const datapoints: { label: string; y: number }[] = [];

        //const total = response.data["total"]-response.data["login"];
        const total = response.data["total"];

        Object.keys(response.data).forEach(key => {
          const labelName = translateEventLabel(key);
          if (!["total"].includes(labelName)) {
            //if (!["total", "login"].includes(labelName)){
            datapoints.push({ "label": labelName, "y": response.data[key] });
          }
        });
        setEventsDataPiePoins(datapoints);

      })
      .catch((error) => {
        console.log(error)
      })

    //RAW EVENTS
    AxiosInstanceLongTimeOut.post("/" + tableName + "/get_" + tableName + "?db=" + operation, request_dict, request_config)
      .then((response) => {
        setRawEvents(response.data || []);
      })
      .catch((error) => console.log(error));


    //EVENTS PER DAY CHART
    const ev_request_dict2 = {
      "collum_name_agregator": "type",
      "date_unit_aggregator": "day",
      "start_date": startDate,
      "end_date": endDate,
      match_filters_dict: {
        "id": equipament
      }
    }

    console.log("REQUEST_AG_EVENTS ", tableName, " requesting ", requestURL);
    AxiosInstanceLongTimeOut.post(requestURL, ev_request_dict2, request_config)
      .then((response) => {
        //console.log(response.data);

        const eventsDataPoints: Series[] = [];

        Object.keys(response.data).forEach(key => {
          const labelName = translateEventLabel(key);
          const dataserie: DataPoint[] = [];

          response.data[key].forEach((val: Record<string, number>) => {
            const date = Object.keys(val)[0];
            dataserie.push({ x: new Date(date), y: val[date] })
          });

          eventsDataPoints.push({
            type: "line",
            showInLegend: true,
            name: labelName,
            xValueFormatString: "MMM DD",
            dataPoints: dataserie,
          })

        })

        setEventsPerTimeDatapoins(eventsDataPoints);
      })
      .catch((error) => {
        console.log(error)
      })



  };



  //-----------------------------------------------------
  //-----------------------------------------------------


  return (
    <DrawerHeader
      title={"Dashboard Equipamento"}
    >

      <Grid container spacing={2} sx={{ mt: 0, ml: 0 }} direction="column">
        {(!equipament || equipament === 'null' || equipament === 'undefined') ? (
          <Grid item xs={12}>
            <Alert severity="info" sx={{ mt: 2, mr: 2 }}>
              <Typography variant="h6">Selecione um equipamento no menu superior para visualizar o dashboard.</Typography>
            </Alert>
          </Grid>
        ) : (
          <>
            <Grid item xs={12}>
              <Paper
                elevation={2}
                sx={{
                  p: { xs: 2.5, md: 3 },
                  bgcolor: 'background.paper',
                  borderLeft: `6px solid ${theme.palette.primary.main}`,
                  borderRadius: 2,
                }}
              >
                <Box>
                  <Typography variant="h4" fontFamily="Saira" fontWeight={900} color="text.primary">Telemetria Individual</Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
                    Consulte o perfil detalhado da máquina selecionada. Visualize mapas de calor de operação, impacto operacional e indicadores de uso isolados e investigação de eventos.
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={2} direction="row">

                <Grid item xs={12} sm={6} md={2.0}>
                  <Paper elevation={5} style={{ padding: "10px 20px 10px 20px", height: "100%", overflowWrap: "anywhere", wordBreak: "break-word" }}>
                    <h2 style={{ fontSize: "1.2rem", margin: "0 0 8px 0" }}>Equipamento</h2>
                    <p style={{ margin: 0 }}>{machineDescription}</p>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={2.0}>
                  <Paper elevation={5} style={{ padding: "10px 20px 10px 20px", height: "100%", overflowWrap: "anywhere", wordBreak: "break-word" }}>
                    <h2 style={{ fontSize: "1.2rem", margin: "0 0 8px 0" }}>Setor</h2>
                    <p style={{ margin: 0 }}>{setor}</p>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={2.0}>
                  <Paper elevation={5} style={{ padding: "10px 20px 10px 20px", height: "100%", overflowWrap: "anywhere", wordBreak: "break-word" }}>
                    <Box mb={2}>
                      <h2 style={{ fontSize: "1.2rem", margin: "0 0 8px 0" }}>Estado</h2>
                      <p style={{ margin: 0 }}>
                        {estado} {userLogged ? `- ${userLogged}` : ""}
                        {(() => {
                          if (!userLogged) return "";
                          const userKey = userLogged.toString().trim().toLowerCase();
                          const userNumKey = !isNaN(Number(userLogged)) ? Number(userLogged).toString() : "";
                          const foundName = usersMap[userKey] || usersMap[userNumKey] || usersMap[userLogged];
                          return (foundName && foundName !== String(userLogged)) ? ` / ${foundName}` : "";
                        })()}
                      </p>
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={2.0}>
                  <Paper elevation={5} style={{ padding: "10px 20px 10px 20px", height: "100%", overflowWrap: "anywhere", wordBreak: "break-word" }}>
                    <h2 style={{ fontSize: "1.2rem", margin: "0 0 8px 0" }}>Horimetro</h2>
                    <p style={{ margin: 0 }}>{horimetro}</p>
                  </Paper>
                </Grid>
                {useMaintenanceModule && (
                  <Grid item xs={12} sm={6} md={2.0}>
                    <Paper elevation={5} style={{ padding: "10px 20px 10px 20px", height: "100%", overflowWrap: "anywhere", wordBreak: "break-word" }}>
                      <h2 style={{ fontSize: "1.2rem", margin: "0 0 8px 0" }}>Próxima preventiva</h2>
                      <p style={{ margin: 0 }}>{proxPreventiva}</p>
                    </Paper>
                  </Grid>
                )}
                <Grid item xs={12} sm={6} md={2.0}>
                  <Paper elevation={5} style={{ padding: "10px 20px 10px 20px", height: "100%", overflowWrap: "anywhere", wordBreak: "break-word" }}>
                    <h2 style={{ fontSize: "1.2rem", margin: "0 0 8px 0" }}>Equipamento reserva</h2>
                    <p style={{ margin: 0 }}>{isReserve}</p>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>

            {/*
        <Grid item xs={12}>
          <Grid container spacing={2} direction="row">
              <Grid item xs={12} sm={6} md={3}>
              Custo de manutencao ultimo ano /grafico?
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
              Distribuicao de manutencao corretiva/preventiva?
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                Quantidade de Horas excedidas do contrato?
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                Numero de contrato?
              </Grid>
          </Grid>
        </Grid>
        */}



            <Grid item xs={12}>
              <Paper elevation={5} style={{ padding: "10px 20px 10px 20px", height: "100%", position: "relative" }}>

                {historical && <Alert severity="warning" sx={{ mb: 1 }}>
              Este mapa não será atualizado automaticamente: é uma visualização de {new Date(endDate).toLocaleDateString('pt-BR')}.
            </Alert>}
            <MapContainer center={mapCenter} zoom={18} style={{ height: '600px', width: '100%' }}>
                  <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />

                  <MapCenterChanger center={mapCenter} equipament={equipament} />

                  <LayersControl position="topright">

                    <LayersControl.Overlay checked name="Mapa detalhado (Planta)">
                      {mapOverlay?.enabled && mapOverlay?.imageUrl && mapOverlay?.topleft && mapOverlay?.topright && mapOverlay?.bottomleft ? (
                        <RotatedImageOverlay
                          url={mapOverlay.imageUrl}
                          topleft={mapOverlay.topleft}
                          topright={mapOverlay.topright}
                          bottomleft={mapOverlay.bottomleft}
                          opacity={mapOverlay.opacity ?? 0.75}
                        />
                      ) : (
                        <ImageOverlay
                          url={imageUrl}
                          bounds={imageBounds}
                          opacity={0.75}
                          className="rotated-overlay"
                        />
                      )}
                    </LayersControl.Overlay>

                    <LayersControl.Overlay checked name="Áreas de Manutenção">
                      <LayerGroup>
                        {areas.filter((a: any) => a.status !== 'Desabilitado' && a.points.length >= 3).map((a: any) => (
                          <Polygon
                            key={a.id}
                            positions={a.points}
                            pathOptions={{ color: a.isMaintenanceArea ? 'orange' : 'blue', weight: 2, fillOpacity: 0.15 }}
                          >
                            <Popup>
                              <b>{a.name}</b><br />
                              {a.isMaintenanceArea && <i>Área de Manutenção<br /></i>}
                              {a.points.length} ponto(s)
                            </Popup>
                          </Polygon>
                        ))}
                      </LayerGroup>
                    </LayersControl.Overlay>

                    <LayersControl.Overlay name="Marcadores">
                      <LayerGroup>
                        {positions.map((pos, idx) => (
                          <Marker key={idx} position={[pos.lat, pos.lng]}>
                            <Popup>
                              <b>User:</b> {pos.user}
                              <br />
                              <b>Time:</b> {pos.timestamp ? new Date(String(pos.timestamp).includes('GMT') || String(pos.timestamp).endsWith('Z') ? pos.timestamp : pos.timestamp + 'Z').toLocaleString() : ""}
                            </Popup>
                          </Marker>
                        ))}
                      </LayerGroup>
                    </LayersControl.Overlay>

                    <LayersControl.Overlay name="Ligações">
                      <Polyline pathOptions={{ color: 'purple' }} positions={multiPolyline} />
                    </LayersControl.Overlay>

                    <LayersControl.Overlay checked name="Mapa de calor">
                      <HeatmapLayer
                        points={positions}
                        longitudeExtractor={(pos: Position) => pos.lng}
                        latitudeExtractor={(pos: Position) => pos.lat}
                        intensityExtractor={(pos: Position) => 1.0}
                      />
                    </LayersControl.Overlay>

                    <LayersControl.Overlay checked name="Última Posição">
                      <LayerGroup>
                        {(() => {
                          let lat = lastValidGps?.latitude ?? lastValidGps?.lat;
                          let lng = lastValidGps?.longitude ?? lastValidGps?.lng;
                          let isApprox = false;

                          if (lat === 0 || lng === 0 || lat == null || lng == null) {
                            if (approxLocation) {
                              lat = approxLocation.lat;
                              lng = approxLocation.lng;
                              isApprox = true;
                            } else {
                              return null;
                            }
                          }

                          const markerState = estado;
                          return (
                            <Marker
                              position={[lat, lng]}
                              icon={getMachineIcon(markerState, equipamentData?.tipo || "")}
                            >
                              {lastValidGps?.gps_imprecise && <GpsTooltip>{gpsWarning(lastValidGps, referenceTime)}</GpsTooltip>}
                              <Popup>
                                <div>
                                  <b>Máquina:</b> {equipamentData?.apelido ? `${equipament} - ${equipamentData.apelido}` : equipament}
                                  <br />
                                  <b>Tipo:</b> {equipamentData?.tipo}
                                  <hr />
                                  <b>Setor:</b> {setor}
                                  <br />
                                  <b>Reserva:</b> {equipamentData?.reserva == 1 || equipamentData?.reserva === true ? "Sim" : "Não"}
                                  <br />
                                  <b>Último Update:</b> {lastHeartbeat?.stamp ? new Date(String(lastHeartbeat.stamp).includes('GMT') || String(lastHeartbeat.stamp).endsWith('Z') ? lastHeartbeat.stamp : lastHeartbeat.stamp + 'Z').toLocaleString() : "N/A"}
                                  <br />
                                  <b>Último GPS:</b> {lastValidGps?.stamp ? new Date(String(lastValidGps.stamp).includes('GMT') || String(lastValidGps.stamp).endsWith('Z') ? lastValidGps.stamp : lastValidGps.stamp + 'Z').toLocaleString() : "N/A"}
                                  <br />
                                  <b>Estado:</b> {markerState}
                                  <br />
                                  <b>Usuário:</b> {lastHeartbeat?.user ?? 0} {(() => {
                                    const hbUser = lastHeartbeat?.user;
                                    const userKey = (hbUser !== undefined && hbUser !== null) ? hbUser.toString().trim().toLowerCase() : "";
                                    const userNumKey = !isNaN(Number(hbUser)) ? Number(hbUser).toString() : "";
                                    const foundName = usersMap[userKey] || usersMap[userNumKey] || (hbUser ? usersMap[hbUser] : undefined);
                                    return (foundName && foundName !== String(hbUser)) ? `/ ${foundName}` : "";
                                  })()}
                                  {isApprox && (
                                    <>
                                      <hr />
                                      <b style={{ color: 'orange' }}>⚠️ Localização aproximada por antena de celular</b>
                                    </>
                                  )}
                                </div>
                              </Popup>
                            </Marker>
                          );
                        })()}
                      </LayerGroup>
                    </LayersControl.Overlay>

                  </LayersControl>

                  {approxLocation && (
                    <Box sx={{ position: 'absolute', bottom: 20, left: '50%', transform: 'translateX(-50%)', zIndex: 1000, width: '80%' }}>
                      <Alert severity="warning" sx={{ boxShadow: 3 }}>
                        Este equipamento está sendo exibido com <b>localização aproximada</b> baseada em antenas de celular, pois não possui sinal de GPS no momento.
                      </Alert>
                    </Box>
                  )}

                </MapContainer>

                <Box sx={{
                  position: 'absolute',
                  top: 30,
                  right: 30,
                  zIndex: 400,
                  backgroundColor: 'rgba(240, 240, 240, 0.85)',
                  padding: '10px 15px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                  pointerEvents: 'none',
                  backdropFilter: 'blur(2px)'
                }}>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', color: '#333' }}>
                    Estados
                  </Typography>
                  {Object.entries(STATE_COLORS).map(([state, color]) => (
                    <Box key={state} sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                      <Box sx={{
                        width: 14,
                        height: 14,
                        borderRadius: '50%',
                        backgroundColor: color,
                        mr: 1,
                        border: '1px solid rgba(0,0,0,0.1)'
                      }} />
                      <Typography variant="body2" sx={{ color: '#444', fontSize: '0.85rem' }}>
                        {state}
                      </Typography>
                    </Box>
                  ))}
                </Box>

              </Paper>
            </Grid>



            <Grid item xs={12}>
              <Grid container spacing={2} direction="row">
                <Grid item xs={12} sm={6} md={useMaintenanceModule ? 4 : 6}>
                  <PieDistribuionEquipament TITLE={"Utilização"} DATA_POINTS={usoDataPiePoins} />
                </Grid>
                {useMaintenanceModule && (
                  <Grid item xs={12} sm={6} md={4}>
                    <PieDistribuionEquipament TITLE={"Disponível / Manuteção"} DATA_POINTS={disponibilidadeDataPiePoins} />
                  </Grid>
                )}
                <Grid item xs={12} sm={6} md={useMaintenanceModule ? 4 : 6}>
                  <PieDistribuionEquipament TITLE={"Eventos"} DATA_POINTS={eventsDataPiePoins} />
                </Grid>
              </Grid>
            </Grid>


            <Grid item xs={12}>
              <HeartbeatTimelineChart
                TITLE="Visão diária"
                DATA={timelineRangePoints}
                startDate={startDate ? dateInputValue(startDate) : undefined}
                endDate={endDate ? dateInputValue(endDate) : undefined}
              />
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={2} direction="row">
                <Grid item xs={12} sm={6} md={6}>
                  <LinePerTimeChart TITLE={"Uso diário"} MAXY={24} DURATION_HOURS TARGET_LINE={horasContratadas} DATA={utilizacaoPerTimeDatapoins} />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <LinePerTimeChart TITLE={"Eventos por dia"} DATA={eventsPerTimeDatapoins} />
                </Grid>
              </Grid>
            </Grid>



            <Grid item xs={12}>
              <BarDistributionChart TITLE={"Horas Trabalhadas por Dia"} DATA={usoDiarioBarPoints} />
            </Grid>

            <Grid item xs={12}>
              <LinePerTimeChart TITLE={"Horimetro"} DATA={
                [
                  {
                    type: "line",
                    showInLegend: false,
                    name: "Ligado",
                    xValueFormatString: "MMM DD",
                    dataPoints: horimetroDatapoins,
                    /*
                    dataPoints: [
                      { x: new Date(2025, 3, 1), y: 1000 },
                      { x: new Date(2025, 3, 2), y: 1020 },
                      { x: new Date(2025, 3, 3), y: 1045 },
                      { x: new Date(2025, 3, 4), y: 1060 },
                      { x: new Date(2025, 3, 5), y: 1060 },
                      { x: new Date(2025, 3, 6), y: 1060 },
                      { x: new Date(2025, 3, 7), y: 1070 },
                    ]
                    */
                  },
                ]}
              />
            </Grid>

            {/*
        <Grid item xs={12}>
          <Paper elevation={5} style={{padding: "10px 20px 10px 20px", height:"100%"}}>
              <h2>Últimas manutenções do equipamento</h2>
              <TableExplorer dbName={operation} tableName={"maintenances"} startDate={startDate} endDate={endDate} match_filters_dict={{"id":equipament}} layout_ops={{topStart: null, topEnd: null,bottomStart: null, bottomEnd: null}} />
          </Paper> 
        </Grid>
        */}
          </>
        )}
      </Grid>


      <Grid container spacing={2} sx={{ mt: 0, ml: 0 }} >
        <Grid item xs={12}>
          <Paper elevation={5} style={{ padding: "10px 20px 10px 20px", height: "100%" }}>
            <h2>Últimas ocorrências do equipamento</h2>
            <TableExplorer
              dbName={operation}
              tableName={"events"}
              headerContent={
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  py: 0.5,
                  px: 1.5,
                  borderRadius: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                  bgcolor: 'background.default'
                }}>
                  <InfoOutlinedIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
                  <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center' }}>
                    Para visualizar o relatório de um evento de batida ou buraco, clique na linha desejada. Para ver todos as ocorrencias, utilize a página Ocorrências identificadas.
                  </Typography>
                </Box>
              }
              startDate={startDate}
              endDate={endDate}
              match_filters_dict={{ "id": equipament }}
              layout_ops={{ topStart: null, topEnd: null, bottomStart: null, bottomEnd: null }}
              modifier_cb={handleRowAction}
              set_table_instance_cb={(table) => { tableInstanceRef.current = table; }}
              columnOrder={["stamp", "type", "setor", "id", "user", "username", "acc_h", "acc_v", "ax", "ay", "jerk_h", "svm", "lat", "lon"]}
              visibleColumns={["stamp", "type", "setor", "id", "user", "username", "acc_h", "acc_v", "ax", "ay", "jerk_h", "svm", "lat", "lon"]}
              order={[[0, "desc"]]}
            />
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper elevation={5} style={{ padding: "10px 20px 10px 20px", height: "100%" }}>
            <h2>Últimos checklists do equipamento</h2>
            <Box sx={{
              '& table.dataTable th': {
                verticalAlign: 'bottom',
                textAlign: 'center !important',
              },
              '& table.dataTable td': {
                textAlign: 'center !important',
              },
              '& table.dataTable td:nth-of-type(6), & table.dataTable th:nth-of-type(6)': {
                borderRight: `2px solid ${theme.palette.divider}`,
              }
            }}>
              {mapLoaded && <TableExplorer
                dbName={operation}
                tableName={"checklists"}
                startDate={startDate}
                endDate={endDate}
                match_filters_dict={{ "id": equipament }}
                layout_ops={{ topStart: null, topEnd: null, bottomStart: null, bottomEnd: null }}
                headerContent={
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    py: 0.5,
                    px: 1.5,
                    borderRadius: 1,
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.default'
                  }}>
                    <InfoOutlinedIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
                    <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center' }}>
                      Para ver todos os checklists preenchidos utilize a página Checklists Preenchidos.
                    </Typography>
                  </Box>
                }
                dataProcessor_cb={(data) => {
                  const processed = data.map((row: any) => {
                    const qorder = (row.qorder || "").toString().split(",").filter((q: string) => q.trim() !== "");
                    const answers = (row.answers || "").toString().split(",");

                    const userIdStr = (row.user !== undefined && row.user !== null) ? row.user.toString().trim().toLowerCase() : "";
                    const userIdStrNumeric = !isNaN(Number(row.user)) ? Number(row.user).toString() : "";
                    const userName = usersMap[userIdStr] || usersMap[userIdStrNumeric] || "";

                    const newRow: any = {
                      stamp: row.stamp || "",
                      user: (row.user !== undefined && row.user !== null) ? row.user.toString() : "",
                      name: userName,
                      id: row.id || "",
                      duration: row.duration || "",
                      status: mapStatus(row.status),
                    };

                    qorder.forEach((q: string, idx: number) => {
                      const qid = q.trim();
                      if (qid !== "") {
                        const checklistId = row.checklist_id || "";
                        const qIndex = parseInt(qid);

                        const qInfo = (questionsMap[checklistId] && questionsMap[checklistId][qIndex])
                          ? questionsMap[checklistId][qIndex]
                          : null;

                        const headerName = qInfo ? qInfo.text : `Q: ${qid}`;
                        let answerVal = answers[idx] !== undefined ? answers[idx] : "";

                        // Try to find the label for this answer
                        if (qInfo && qInfo.answers) {
                          const foundOption = qInfo.answers.find((a: any) => a.value === answerVal);
                          if (foundOption) {
                            answerVal = foundOption.label;
                          }
                        }

                        newRow[headerName] = answerVal;
                      }
                    });

                    return newRow;
                  });
                  return processed;
                }}
              />}
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {selectedEvent && (
        <ImuChartModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          tid={selectedEvent.tid}
          stamp={selectedEvent.stamp}
          db={operation || ""}
          eventData={selectedEvent}
        />
      )}
    </DrawerHeader>
  );
}
